import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Chip,
  Box,
  Typography,
} from "@material-ui/core";
import api from "../../services/api";
import { toast } from "react-toastify";

const groupTags = (tags) => {
  const groups = tags.filter((tag) => tag.isGroup);
  const ungrouped = tags.filter((tag) => !tag.isGroup && !tag.parentId);

  return [
    ...groups.map((group) => ({
      group,
      tags: tags.filter((tag) => !tag.isGroup && tag.parentId === group.id),
    })),
    { group: null, tags: ungrouped },
  ].filter((section) => section.tags.length > 0 || section.group);
};

const TagSelectModal = ({ open, onClose, ticketId, onSync }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTagIds, setSelectedTagIds] = useState([]);

  useEffect(() => {
    if (open) {
      (async () => {
        setLoading(true);
        try {
          const { data } = await api.get("/tags");
          setTags(Array.isArray(data) ? data : []);

          if (ticketId) {
            const { data: ticketData } = await api.get(`/tickets/${ticketId}`);
            const ticketTags = Array.isArray(ticketData.tags) ? ticketData.tags : [];
            const nextTagIds = ticketTags.length
              ? ticketTags.map((tag) => tag.id)
              : ticketData.tag?.id || ticketData.tagId
                ? [ticketData.tag?.id || ticketData.tagId]
                : [];
            setSelectedTagIds(nextTagIds);
          }
        } catch (err) {
          toast.error("Erro ao carregar etiquetas");
        }
        setLoading(false);
      })();
    }
  }, [open, ticketId]);

  const handleSelectTag = (tagId) => {
    setSelectedTagIds((prev) =>
      prev.includes(tagId)
        ? prev.filter((selectedTagId) => selectedTagId !== tagId)
        : [...prev, tagId]
    );
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticketId}`, { tagIds: selectedTagIds });

      toast.success("Etiquetas atualizadas!");
      if (onSync) onSync();
      onClose();
    } catch (err) {
      toast.error("Erro ao vincular etiquetas");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Selecionar Etiquetas - Ticket #{ticketId}</DialogTitle>
      <DialogContent dividers>
        {loading && tags.length === 0 ? (
          <Box display="flex" justifyContent="center" m={2}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column">
            {groupTags(tags).map((section) => (
              <Box key={section.group?.id || "ungrouped"} mb={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  {section.group?.name || "Sem grupo"}
                </Typography>
                <Box display="flex" flexWrap="wrap">
                  {section.tags.map((tag) => {
                    const isSelected = selectedTagIds.includes(tag.id);
                    return (
                      <Chip
                        key={tag.id}
                        label={tag.name}
                        onClick={() => handleSelectTag(tag.id)}
                        style={{
                          backgroundColor: isSelected ? tag.color : "rgba(0, 0, 0, 0.08)",
                          color: isSelected ? "#FFF" : "rgba(0, 0, 0, 0.87)",
                          fontWeight: isSelected ? "bold" : "normal",
                          margin: 4,
                          cursor: "pointer",
                          border: isSelected ? "2px solid rgba(0,0,0,0.3)" : "none",
                        }}
                      />
                    );
                  })}
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TagSelectModal;
